/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Skill_S2Inputs */

const en_mk_tut_skill_s2 = /** @type {(inputs: Mk_Tut_Skill_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach an example file if it helps — the report template you already use, for instance.`)
};

const id_mk_tut_skill_s2 = /** @type {(inputs: Mk_Tut_Skill_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lampirkan berkas contoh kalau perlu — misalnya template laporan yang selama ini dipakai.`)
};

/**
* | output |
* | --- |
* | "Attach an example file if it helps — the report template you already use, for instance." |
*
* @param {Mk_Tut_Skill_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_skill_s2 = /** @type {((inputs?: Mk_Tut_Skill_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Skill_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_skill_s2(inputs)
	return en_mk_tut_skill_s2(inputs)
});